import {
  Box,
  CircularProgress,
  Grid,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import user from "../../Utils/Images/User.png";
import Loader from "../Loader/Loader";
const RecentUserTable = ({ data, loading }) => {
  return (
    <>
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <Loader />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            border: "1px solid #DDDDDD",
            height: "95%",
            mt: "10px",
            overflow: "auto",
            "&:hover": {
              "::-webkit-scrollbar": {
                width: "5px",
                borderRadius: "10px",
              },
              "::-webkit-scrollbar-thumb": {
                bgcolor: "gray",
                borderRadius: "10px",
              },
            },
          }}
        >
          {/* first column */}
          <Grid container>
            <Grid item xs={1} md={1}>
              {data?.map((item, i) => (
                <Paper
                  sx={{
                    border: "0.5px solid #DDDDDD",
                    borderRadius: "0px",
                    height: "70px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                  }}
                  key={item.id}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",
                    }}
                  >
                    {i + 1}
                  </Typography>
                </Paper>
              ))}
            </Grid>

            {/* Second Column */}

            <Grid item xs={2} md={2}>
              {data?.map((item, i) => (
                <Paper
                  sx={{
                    border: "0.5px solid #DDDDDD",
                    borderRadius: "0px",
                    height: "70px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                  }}
                  key={item.id}
                >
                  <Box
                    sx={{
                      width: { xs: "50px", md: "50px" },
                      height: { xs: "50px", md: "50px" },
                    }}
                  >
                    <img
                      width={"100%"}
                      height={"100%"}
                      style={{ borderRadius: "10px" }}
                      src={
                        item.profile_img
                          ? `https://api-qhealth.equitysofttechnologies.com//upload/profile_img/${item.profile_img}`
                          : user
                      }
                      alt="preview"
                    />
                  </Box>
                </Paper>
              ))}
            </Grid>

            {/* Third Column */}

            <Grid item xs={4.5} md={4.5}>
              {data?.map((item, i) => (
                <Paper
                  sx={{
                    border: "0.5px solid #DDDDDD",
                    borderRadius: "0px",
                    height: "70px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                    textOverflow: "ellipsis",
                    overflow: "auto",
                    maxWidth: "100%",
                    "&:hover": {
                      overflow: "visible",
                    },
                  }}
                  key={item.id}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",
                    }}
                  >
                    {item.full_name}
                  </Typography>
                </Paper>
              ))}
            </Grid>

            {/* Fourth Column */}

            <Grid item xs={4.5} md={4.5}>
              {data?.map((item, i) => (
                <Paper
                  sx={{
                    border: "0.5px solid #DDDDDD",
                    borderRadius: "0px",
                    height: "70px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                  }}
                  key={item.id}
                >
                  {" "}
                  <Tooltip title={item.email}>
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        textOverflow: "ellipsis",
                        overflow: "auto",
                        maxWidth: "100%",
                      }}
                    >
                      {item.email}
                    </Typography>
                  </Tooltip>
                </Paper>
              ))}
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};

export default RecentUserTable;
